$('.resource-doc__item[data-toggle="collapse"]').click(function(){
    $(this).parent().toggleClass('active');
});

$(document).ready(function(){
    const tabs = ['#Documents','#Professional','#Announcements'];
    $('.resources-nav__item').click(function(){
        location.hash = $(this).attr('href')
    })
    $('body').scrollspy({ target: '#list-documents', offset: 100})
})

$('[data-resources-tab]').click(function(){
    $($(this).attr('data-resources-tab')).click();
})